<template>
    <div class="bg re_sizing">
        <div class="title re_font_18">
            <van-icon @click="goBack(1)" class="icon" name="arrow-left" size="22" />
            <div>开水壶单身泡泡会员协议</div>
        </div>
        <div class="blank"></div>
        <div class="content">
            <div>
                中道新职坊科技发展有限公司（以下简称“中道新职坊”或“中道”）在此特别提醒您，在您注册成为单身泡泡会员之前，请认真阅读《单身泡泡会员协议》（以下简称“本协议”），确保您充分理解各条款。限制或免除责任条款可能以黑体加粗形式提示您注意，您应重点阅读。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您不得注册、登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为对本协议的接受，并同意接受各项条款的约束。
            </div>
            <div>
                本协议约定中道与您之间关于“单身泡泡会员”服务的各项事项。“会员”是指注册、登录、使用本协议项下中道提供的各种服务的个人（以下称“会员”或“您”）。会员服务是有偿的增值服务，您必须完全同意本协议，并完成付费，才能享受相关服务。本协议是基于“开水壶”软件的《用户协议》而制定，是其不可分割的一部分。同时，中道新职坊不时发布的关于会员服务的各种规范、规则等也是本协议的一部分。您选择接受本协议，开通会员服务成为会员用户，即表示您同意接受本协议《用户协议》及各种规范、规则的各项约束，并将遵守。如果您不接受本协议，则不能享受会员服务。
            </div>
            <div>
                本协议可由中道新职坊随时更新，更新后的协议一旦公布即代替原来的协议内容，恕不再另行通知，您可在App内查阅最新版本。
            </div>
            <div class="h1">一、总则</div>
            <div>
                1、开水壶是由中道新职坊创建、运营的社交产品。 <br />
                2、开水壶用户是指完成全部注册流程，愿意接受开水壶《用户协议》并在开水壶相关使用规范的规定下使用开水壶服务的注册用户。 <br />
                3、单身泡泡会员服务是开水壶为开水壶用户提供的有偿增值服务，用户向开水壶支付相关费用后，方可享受专门为会员提供的各项服务。<br />
                4、单身泡泡会员必须遵守开水壶《用户协议》及本协议条款。
            </div>
            <div class="h1">二、服务费用</div>
            <div>
                1、单身泡泡会员增值服务的具体资费标准，以开水壶App公布的价格为准，用户可通过第三方支付方式进行购买。中道将根据不同的购买方式和数量，向用户提供不同幅度的优惠，具体优惠政策以会员中心相关页面的公告、说明或会员资格支付页面显示的内容为准。 <br />
                2、您可以通过开水壶App查询您的账号信息详情，包括已开通的服务内容、服务期限、消费金额、交易状态等 。 <br />
                3、中道有权基于自身业务发展需要调整会员服务费用标准，调整后的费用标准将在会员资格支付页面显示，用户按调整后的服务费用标准支付后方可享有或延续会员资格。已按原会员服务费用标准购买会员服务的用户，其会员资格在已取得的会员资格期限内不受影响。
            </div>
            <div class="h1">三、服务内容</div>
            <div>
                1、中道将为单身泡泡会员提供多种专享的增值服务，具体内容以会员中心页面展示内容为准。 <br />
                2、中道有权基于自身业务发展需要调整会员服务内容。就前述调整，中道将在相应页面进行通知或公告。
            </div>
            <div class="h1">四、服务的开通和终止</div>
            <div>
                1、用户完成注册程序并通过平台提供的付费途径完成会员费用的支付后，即取得相应会员资格。 <br />
                2、提交申请并开通会员资格时，您需确保提交的个人资料真实、准确、完整、合法有效。当个人资料发生变化时，应及时对注册资料予以修改、更新，否则由此造成的会员权利不能全面有效行使或其他任何后果、责任由您自行承担。 <br />
                3、会员资格有效期自会员服务开通之时起算，具体期限可以登录开水壶App相关会员页面查看。 <br />
                4、会员资格有效期届满后，中道将终止向您提供会员增值服务，您可以通过续交会员服务费用延续会员资格。 <br />
                5、会员在会员资格有效期内续费，会员资格有效期将在原有效期基础上相应顺延。
            </div>
            <div class="h1">五、会员的权利和义务</div>
            <div>
                1、单身泡泡会员平等享有会员的权利，同时应遵守开水壶平台的各项规范、规则，包括但不限于本协议、《用户协议》、《隐私政策》等. <br />
                2、因违反本协议第五条第1款所述的相关协议或平台规则导致会员服务被暂停使用而导致的损失，由您自行承担。 <br />
                3、会员资格有效期内，会员可以享受相应的增值服务。 <br />
                4、您了解并同意，单身泡泡会员服务属于虚拟权益，您购买、获取后，无论是否实际使用相应服务，均不支持退货、换货、兑换现金、抵扣其他商品或服务。除非平台另有说明，已由特定账号获取的单身泡泡会员服务、权益，无法转让给其他账号。 <br />
                5、会员自行承担在开水壶中传送、发布信息及使用会员服务法律责任。会员使用相关服务，均应遵守各项法律法规、规章、规范性文件（以下简称“法律法规”）以及平台协议及规则。 <br />
                6、会员资格开通后，您应谨慎合理的保存、使用用户名和密码，不得将账号借予他人使用。否则，您应承担由此产生的全部责任。同时，中道在该种情况下有权作出独立判断，可采取暂停或关闭用户会员资格等措施。 <br />
                7、会员服务仅限于申请账号个人使用，不得用于商业等用途；会员服务期内不能在账号之间转移，不得赠与、借用、转让或售卖。 <br />
                8、会员不得以盗窃、利用系统漏洞等非法途径获取或购买会员服务，否则因此导致的损失由会员自行承担。
            </div>
            <div class="h1">六、中道新职坊的权利和义务</div>
            <div>
                1、中道新职坊应保证会员服务的正常使用出现技术故时应尽快排除，但对于会员因此产生的任何损失，中道新职坊不承担责任 。 <br />
                2、因不可抗力造成会员服务提供的中断或其它缺陷，中道新职坊不承担任何责任，但将尽力减少因此给会员造成的损失和影响。 <br />
                3、会员在使用开水壶服务时，故意作出有损平台或其他开水壶用户合法权益的行为，或违反《用户协议》的相关约定，中道新职坊有权取消会员资格或中断一项或多项会员服务而无须给予任何补偿，与此同时，中道新职坊保留追究会员法律责任的权利。 <br />
                4、会员在使用开水壶服务时，存在违反法律法规的行为，中道新职坊有权取消会员资格而无须给予任何补偿，且会员须自行承担全部责任。
            </div>
            <div class="h1">七、其他</div>
            <div>
                1、中道新职坊不时发布的关于会员服务的规范、规则等，是本协议不可分割的一部分。 <br />
                2、本协议未约定事项，参照《用户协议》执行;本协议约定与《用户协议》不一致的以本协议的约定为准。 <br />
                3、本协议的解释，效力及纠纷的解决，适用中华人民共和国法律。若会员和中道新职坊之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，会员同意将纠纷或争议提交中道新职坊住所地有管辖权的人民法院管辖。
            </div>
        </div>
    </div>
</template>

<script setup>
// import { getDrawConfig } from './api.js'
import { ref, onMounted } from 'vue';
const ruleInfo = ref('{withdrawalRules}');
const goBack = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        try {
            appJsImp.finish()
        } catch (error) {
            android.finish()
        }
    }
    if (isiOS) {
        window.webkit.messageHandlers.AppModel.postMessage('finish')
    }
}
</script>

<style lang="less" scoped>
@import url(./rule.less);
</style>